<template>
  <el-collapse value="1">
    <el-collapse-item name="1">

      <template #title>
        <div style="margin-left: 7px;">
        <i class="fa-solid fa-user-tie"></i>
        &nbsp;
        <span>{{$t('Müstəqil_ekspert_qiymətləndirməsi')}}</span>
        </div>
      </template>
      <card>
        <div class="col-12" v-if="hasRoles(['Tech expertise operator'])" style="text-align: right">
          <el-button size="small" type="danger" @click="evaluationClear(3)">{{$t('Qiymətləndirməni təmizlə')}}</el-button>
        </div>
        <div class="row">
          <div class="col-9"></div>
          <div class="col-3">
            <div class="text-center" :class="status ? statusColor(status) : ''">
              <span style="font-size: var(--font-primary); color: white">
                {{ item.techExpertStatusName }}
              </span>
            </div>
          </div>
        </div>
        <el-form ref="initialForm" :disabled="readonly" :rules="rules" :model="item" v-loading="loading"
          :label-position="labelPosition" :validate-on-rule-change="false">
          <div>
            <div class="row">
              <div class="col-md-4">
                <el-form-item :label="$t('Müstəqil_ekspert')" prop="serviceCenterId" class="service-center-item">
                  <indepentend-users-el :readonly="readonly" :size="'normal'" v-model="item.serviceCenterId" />
                </el-form-item>
              </div>
            </div>
            <div class="row" style="padding-bottom: 10px">
              <div class="col-md-4">
                <el-form-item :label="$t('İlkin_məbləğ')" prop="initialIndepentendExpertSum">
                  <el-input size="small" v-decimal v-model="item.initialIndepentendExpertSum"></el-input>
                </el-form-item>
              </div>

              <div class="col-md-4">
                <el-form-item :label="$t('Qeyd')" prop="initialIndepentendExpertNote">
                  <el-input size="small" v-model="item.initialIndepentendExpertNote"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4" style="margin-top: 45px">
                <el-button size="small" :disabled="saveloading" type="primary" v-if="!readonly" @click="save(6)">{{$t('Yadda_saxla')}}</el-button>
                <created-label :class="{'higher-position': readonly }" v-if="item.initialIndepentendExpertDateStr"
                  :type="2" :created="item.initialIndepentendExpertDateStr" />
              </div>
            </div>
            <div class="custom-upload-left">
              <dir class="col-12">
                <upload :key="uploadKey" ref="upload" :sourcetype="13" :disabled="readonly" :sourceId="item.claimId"
                  :autoupload="true" :downloadAll="false"></upload>
              </dir>
            </div>

          </div>
        </el-form>
        <hr v-if="isInitialSumValid">

        <el-form ref="offeredForm" :disabled="readonly" :rules="rules" :model="item" v-if="isInitialSumValid"
          :label-position="labelPosition" :validate-on-rule-change="false">
          <div>
            <div class="row" style="padding-bottom: 10px">
              <div class="col-md-4">
                <el-form-item :label="$t('Təklif_olunan_məbləğ')" prop="offeredIndepentendExpertSum">
                  <el-input size="small" v-decimal v-model="item.offeredIndepentendExpertSum"></el-input>
                </el-form-item>
              </div>

              <div class="col-md-4">
                <el-form-item :label="$t('Qeyd')" prop="offeredIndepentendExpertNote">
                  <el-input size="small" v-model="item.offeredIndepentendExpertNote"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4" style="margin-top: 45px">

                <el-button size="small" :disabled="saveloading" type="primary" v-if="!readonly" @click="save(7)">{{$t('Yadda_saxla')}}</el-button>
                <created-label :class="{'higher-position': readonly }" v-if="item.offeredIndepentendExpertDateStr"
                  :type="2" :created="item.offeredIndepentendExpertDateStr" />
              </div>
            </div>
            <div class="custom-upload-left">
              <dir class="col-12">
                <upload ref="upload" :key="uploadKey" :sourcetype="14" :disabled="readonly" :sourceId="item.claimId"
                  :autoupload="true" :downloadAll="false"></upload>
              </dir>
            </div>
          </div>
        </el-form>
        <hr v-if="isOfferedSumValid">
        <el-form ref="finalForm" :disabled="readonly" :rules="rules" :model="item" v-if="isOfferedSumValid"
          :label-position="labelPosition" :validate-on-rule-change="false">
          <div>
            <div class="row" style="padding-bottom: 10px">
              <div class="col-md-4">
                <el-form-item :label="$t('Yekun_məbləğ')" prop="finishIndepentendExpertSum">
                  <el-input size="small" v-decimal type="number" v-model="item.finishIndepentendExpertSum"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4">
                <el-form-item :label="$t('Qeyd')" prop="finishIndepentendExpertNote">
                  <el-input size="small" v-model="item.finishIndepentendExpertNote"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4" style="margin-top: 45px">
                <el-button size="small" :disabled="saveloading" type="primary" v-if="!readonly" @click="save(8)">{{$t('Yadda_saxla')}}</el-button>
                <created-label :class="{'higher-position': readonly }" v-if="item.finishIndepentendExpertDateStr"
                  :type="2" :created="item.finishIndepentendExpertDateStr" />
              </div>
            </div>
            <div class="custom-upload-left">
              <dir class="col-12">
                <upload ref="upload" :key="uploadKey" :sourcetype="15" :disabled="readonly" :sourceId="item.claimId"
                  :autoupload="true" :downloadAll="false"></upload>
              </dir>
            </div>

          </div>
        </el-form>
      </card>
    </el-collapse-item>
  </el-collapse>
</template>


<script>
  import CreatedLabel from "./CreatedLabel.vue";
  import Upload from "../components/Upload.vue";
  import { UpdateTechExpert, TechExpertEvaluationClear } from "../../services/claim";
  import IndepentendUsersEl from './IndepentendUsersEl.vue';
  import { isNull } from "pdfmake/build/pdfmake";
  import { labelPosition} from "../../services/helper";
  export default {
    components: { IndepentendUsersEl, Upload, CreatedLabel },
    props: {
      value: Object,
      readonly: { type: Boolean, default: false },
    },
    data() {
      return {
        loading: false,
        item: this.value,
        status: this.value.status,
        uid: this.$store.state.user.id,
        saveloading: false,
        uploadKey: 0,
        roles: this.$store.state.user.roles,
        labelPosition: labelPosition,
      };
    },

    methods: {
      hasRoles(requiredRoles) {
        return requiredRoles.some(role => this.roles.includes(role));
      },
      evaluationClear(type) {
        let typeName = '';
        if (type === 3) {
          typeName = this.$t('Müstəqil_ekspert_qiymətləndirməsini');
        }
        this.$confirm(`${typeName} təmizləmək istəyirsiz?`, this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        }).then(() => {
          this.loading = true;
          TechExpertEvaluationClear(this.item.claimId, type, this.uid).then((response) => {
            this.loading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0]
                    ? response.data.errors[0]
                    : this.$t('Səhv_əməliyyat'),
                });
              } else {
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
                this.$emit("refresh");
                this.uploadKey++;
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        });
      },

      statusColor(status) {
        switch (status) {
          case 12:
            return "p-2 mb-2 bg-info text-dark rounded";
          case 13:
            return "p-2 mb-2 bg-warning text-dark rounded";
          case 14:
            return "p-2 mb-2 bg-success text-dark rounded";
          case 15:
            return "p-2 mb-2 bg-danger text-dark rounded";
          default:
            return "text-default";
        }
      },
      save(stage) {
        let formRef;
        if (stage === 6) formRef = 'initialForm';
        else if (stage === 7) formRef = 'offeredForm';
        else if (stage === 8) formRef = 'finalForm';

        this.$refs[formRef].validate((valid) => {
          if (valid) {
            this.saveloading = true;
            this.item.stage = stage;
            this.item.commandUserId = this.uid;

            UpdateTechExpert(this.item).then((response) => {
              this.loading = false;
              if (response.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: this.$t('Uğurlu_əməliyyat'),
                  });
                  this.$emit("refresh");
                  setTimeout(() => {
                    this.saveloading = false;
                  }, 5000);
                }
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('Səhv_əməliyyat'),
                });
              }
            });
          }
        });
      },
    },
    computed: {
      isInitialSumValid() {
        return this.item.initialIndepentendExpertSum && this.item.initialIndepentendExpertSum !== 0;
      },
      isOfferedSumValid() {
        return this.item.offeredIndepentendExpertSum && this.item.offeredIndepentendExpertSum !== 0;
      },
      rules() {
        return {
          indepentendRespUid: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: []
            },
          ],
          initialIndepentendExpertSum: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: []
            },
          ],
          offeredIndepentendExpertSum: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: []
            },
          ],
          finishIndepentendExpertSum: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: []
            },
          ],
        }
      },
    },
    watch: {
      value() {
        this.status = this.value.status;
        this.item = this.value;
      },
    },
    mounted() {
      this.$nextTick(() => {
        if (this.$refs.initialForm) this.$refs.initialForm.clearValidate();
        if (this.$refs.offeredForm) this.$refs.offeredForm.clearValidate();
        if (this.$refs.finalForm) this.$refs.finalForm.clearValidate();
      });
    }
  };
</script>

<style lang="scss" scoped>
  .custom-form-item {
    margin-bottom: 0 !important;
  }

  .custom-upload-left {
    margin-left: -15px;
    margin-top: -10px;
  }

  .record-label {
    font-size: var(--font-primary);
    font-style: italic;
  }

  .indepentend-width {
    width: 380px;
  }

  .higher-position {
    margin-top: 10px;
  }
</style>